exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agree-text {\n  font-size: 1em; }\n  .agree-text .head {\n    margin-top: 0; }\n  .agree-text p {\n    margin-top: 0; }\n  .agree-text ul {\n    padding-left: 20px; }\n\n.agree-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .agree-footer .btn[disabled] {\n    background: #ccc !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/src/app/agree/agree.component.scss
// module id = ../../../../../src/app/agree/agree.component.scss
// module chunks = 1